<form [formGroup]="brandForm" class="flex flex-col gap-6" (ngSubmit)="onSubmit()" novalidate>
  <div>
    <p-floatlabel variant="in" class="mb-2">
      <input pInputText type="text" id="nom" formControlName="nom" pSize="large" class="w-full" />
      <label for="nom">Nom</label>
    </p-floatlabel>
    @if (brandForm.get('nom')?.dirty && brandForm.get('nom')?.hasError('required')) {
      <p-message severity="error" variant="simple">Le nom est obligatoire</p-message>
    }
  </div>

  <div class="flex flex-row justify-between">
    <p-button label="Annuler" icon="pi pi-times" severity="danger" variant="text" type="button" (click)="hideDialog()" />
    <p-button label="Sauvegarder" icon="pi pi-save" iconPos="right" type="submit" [disabled]="!brandForm.valid" [loading]="isSendingDatas"/>
  </div>
</form>